const messages = {
    heading: "Projects",
    lead: "Project cards or links will appear here — add your work.",
};

export default messages;
